import API from '@/api';
import _ from 'lodash';
import * as utils from '@/store/utils';

const allowKeys = [
    'weight',
    'activity',
    'grade',
    'subject',
    'pdfLink',
    'id',
];

export default {
    namespaced: true,
    state: {},
    actions: {
        List(__, params) {
            return API.PostExam.PrivateList({ params }).catch(utils.handleAPIError);
        },
        async Create({ dispatch }, data) {
            return API.PostExam.PrivateCreateResource(
                await dispatch('convertForm', {
                    ..._.pick(data, allowKeys),
                    online: true,
                }),
            )
                .then((res) => {
                    utils.handleAPISuccess('成功');
                    return res;
                })
                .catch(utils.handleAPIError);
        },
        async Update({ dispatch }, { id, data }) {
            return API.PostExam.PrivateUpdateResource(
                id,
                await dispatch('convertForm', {
                    ..._.pick(data, allowKeys),
                    online: true,
                }),
            )
                .then(() => utils.handleAPISuccess('成功'))
                .catch(utils.handleAPIError);
        },
        Delete(__, id) {
            return API.PostExam.PrivateDeleteResource(id)
                .then(() => utils.handleAPISuccess('成功'))
                .catch(utils.handleAPIError);
        },
        convertForm(__, form) {
            const data = _.cloneDeep(form);
            return new API.FormData(data, [
                {
                    urls: [data.pdfLink],
                    ext: (mimetype) => ({
                        'image/png': 'png',
                        'image/jpeg': 'jpg',
                        'application/pdf': 'pdf',
                    }[mimetype] || 'png'),
                },
            ]);
        },
    },
};
